import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import Rooms from "@/components/site/Rooms";
import ContactCta from "@/components/site/ContactCta";
import Faq from "@/components/site/Faq";
import { applySeo, ROUTE_SEO } from "@/lib/seo";

export default function RoomsPage() {
  useEffect(() => {
    applySeo(ROUTE_SEO["/rooms"]);
  }, []);

  return (
    <div className="bg-sand-50 text-ink font-sans antialiased min-h-screen">
      <Navbar />
      <main>
        <section className="py-16 bg-sand-100 border-b border-sand-200" data-testid="rooms-page-header">
          <div className="max-w-7xl mx-auto px-6">
            <span className="text-xs font-mono-clean text-terracotta uppercase tracking-wider font-semibold">
              Sleep Steps from the Wave
            </span>
            <h1 className="font-display text-4xl sm:text-5xl font-bold text-ocean-900 mt-3">
              Rooms & ocean view apartments
            </h1>
            <p className="text-sm text-fog mt-4 max-w-2xl leading-relaxed">
              Beachfront accommodation at Sorake Beach, Lagundri Bay — from
              value surfer rooms at $45 a night to ocean view apartments for
              families, groups and monthly remote-work stays from $700.
            </p>
          </div>
        </section>
        <Rooms />
        <Faq />
        <ContactCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
